<template>
	<NavSidebarLayout
		:show-left-sidebar="showLeftSidebar"
		:scrollable="false"
	>
		<header class="my-commitments-layout__header">
			<div class="my-commitments-layout__title-row">
				<div class="my-commitments-layout__title-position">
					<MobileMenuIcon
						v-if="showMobileMenuIcon"
						class="my-commitments-layout__mobile-menu-icon"
						@click="onMobileMenuIconClicked"
					/>
					<div class="my-commitments-layout__title-layout">
						<div class="my-commitments-layout__title-text">{{ $t( "slice-actionItems.layouts.MyCommitmentsLayout.actionItemsTitle" ) }}</div>
					</div>
				</div>
			</div>
		</header>

		<main class="my-commitments-layout__tab-container">
			<router-view v-bind="$attrs" />
		</main>
	</NavSidebarLayout>
</template>

<script>
import ScreenSizeDetector from "screen-size-detector";

import { MobileMenuIcon } from "@teaming/common-ui";
import { foundation } from "@teaming/slice-engine";

export default {
	name: "MyCommitmentsLayout",

	components: {
		MobileMenuIcon,
	},

	inject: [ "userProfile", ],

	data() {
		return {
			screenWidth: window.innerWidth,
		};
	},

	props: {
		showLeftSidebar: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		showMobileMenuIcon() {
			return foundation().config.permitMobileMenu;
		},
	},

	methods: {
		sendTelemetry() {
			// the 1 second pause is a hack until we can get an FSM (or similar)
			// around our amplitude module and queue up telemetry events to be
			// sent *after* we set the user profile so that events don't go w/o them
			setTimeout( () => {
				foundation().telemetry.user.viewedMyActionItems();
			}, 1000 ); // eslint-disable-line no-magic-numbers
		},
		onMobileMenuIconClicked( e ) {
			e.preventDefault();
			e.stopPropagation();
			foundation().sidebar.open();
		},
	},

	created() {
		this.screen = new ScreenSizeDetector( {
			onWidthChange: () => {
				this.screenWidth = this.screen.width;
			},
		} );
	},

	mounted() {
		this.sendTelemetry();
	},

	unmounted() {
		this.screen.removeMainCallback( "widthchange" );
		this.screen = undefined;
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
}
</style>

<style lang="scss" scoped>
.my-commitments-layout__header {
	width: 100%;
	border-bottom: 0.0625rem solid $my-commitments-layout-header-border-color;
	display: flex;
	flex-direction: column;
}

.my-commitments-layout__tab-container {
	@include auto-y-scroll();
	width: 100%;
	flex: 1;
	position: relative;
	display: flex;
	flex-direction: column;
}

.my-commitments-layout__title-row {
	padding: 1.125rem 0 1.125rem 0;
	@include font-and-line-for(2);
	color: $my-commitments-layout-title-font-color;
	overflow-y: hidden;

	@include for-size-and-larger('sm') {
		padding: 1.625rem 1rem 1.625rem 2rem;
	}
}

.my-commitments-layout__title-position {
	position: relative;
}

.my-commitments-layout__title-layout {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex: 1;

	@include for-size-and-larger('md') {
		gap: 0.5rem;
		justify-content: flex-start;
	}

	@include for-size('xs') {
		margin-left: 2.5rem;
	}
}

.my-commitments-layout__title-text {
	font-weight: bold;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	@include font-and-line-for(1);

	@include for-size('sm') {
		@include font-and-line-for(2);
	}
}

.my-commitments-layout__mobile-menu-icon {
	margin: 0;
	padding: 0;

	position: absolute;
	top: 0;
	left: 0;

	@include for-size('md') {
		display: none;
	}
}

</style>
